import PropTypes from "prop-types"
import React from "react"

import InlineNotice from "src/components/InlineNotice"

const ManualBankWarning = ({ copy }) => (
  <InlineNotice
    variant="warning"
    icon="fa-triangle-exclamation"
    iconStyle="solid"
  >
    <p className="m-0">{copy.manualBankWarning}</p>
    <a
      href="/account/settings/payment_methods"
      target="_blank"
      rel="noopener noreferrer"
      className="font-semibold"
    >
      {copy.manualBankLink}
    </a>
  </InlineNotice>
)

ManualBankWarning.propTypes = {
  copy: PropTypes.shape({
    manualBankLink: PropTypes.string,
    manualBankWarning: PropTypes.string,
  }).isRequired,
}

export default ManualBankWarning
